import Api from "../../api/index";
import transform_files_to_direct_upload from "../../utils/transform_files_to_direct_upload";
import transform_photo_compressed_to_signed_ids from "../../utils/transform_photo_compressed_to_direct_upload";

const FlowExecution = {
  namespaced: true,

  state: {
    done_flow: {},
    done_groups: [],
    done_steps: [],

    one_done_group: {},
    one_done_step: {}
  },

  getters: {
    groupToExecute: (state, getters) => {
      const done_steps_to_execute = getters.doneStepsToExecute;
      if (done_steps_to_execute && done_steps_to_execute.length) {
        const first_step = done_steps_to_execute[0];
        const group_id = first_step.done_group_id;
        return group_id;
      } else {
        const ordered_steps = getters.orderedDoneSteps;
        return ordered_steps[0].done_group_id;
      }
    },
    doneStepsToExecute: (state, getters) => {
      let ordered_done_steps = getters.orderedDoneSteps;

      return ordered_done_steps.filter((step) => step.status != "done")
    },
    isThereAnyBlocked: (state, getters) => {
      let ordered_done_steps = getters.orderedDoneSteps;

      return ordered_done_steps.filter((step) => step.status == "blocked")
    },
    orderedDoneSteps: (state) => {
      let ordered_done_steps = [];

      if (state.done_steps && state.done_steps.length) {
        const first_done_step = state.done_steps.find((done_step) => done_step.step_previous.length === 0);
        ordered_done_steps.push(first_done_step);
        let current = first_done_step;
  
        while(current && current.step_next.length) {
          let next = state.done_steps.find((step) => step.step_id == current.step_next[0]);
          if (next) {
            ordered_done_steps.push(next);
            current = next;
          } else {
            current = null;
          }
        }
      }

      return ordered_done_steps;
    },
    orderedStepsByGroupId: (state) => (group_id) => {
      const group = state.done_groups.find((group) => group.id == group_id);
      const steps = state.done_steps.filter(({done_group_id}) => done_group_id === group.id);
      
      if (steps && steps.length) {
        let ordered_steps = [];

        let first_step = steps.find((step) => step.step_id == group.group_first_step_id);
        ordered_steps.push(first_step);
        let current = first_step;
  
        while(current && current.step_next.length) {
          let next = steps.find((step) => step.step_id == current.step_next[0]);
          if (next) {
            ordered_steps.push(next);
            current = next;
          } else {
            current = null;
          }
        }
        
        return ordered_steps;
      }

      return [];
    },
    doneStepsBasedOnOneDoneGroup(state, getters, rootState) {
      return state.done_steps.filter((ds) => ds.done_group_id == state.one_done_group.id);
    },
    currentStepToExecute(state) {
      const blocked_step = FlowExecution.getters.blockedStep(state);
      if (blocked_step) {
        return blocked_step;
      } else {
        return state.done_steps.filter((ds) => ds.done_at == null && ds.done_by_id == null)[0];
      }
    },
    currentGroup(state) {
      return state.done_groups.find((dg) => dg.id == state.one_done_step.done_group_id);
    },
    isOneDoneStepLastStep(state) {
      return state.done_steps.findIndex((ds) => ds.id == state.one_done_step.id) == state.done_steps.length - 1;
    },
    currentDoneStepIndex(state) {
      return FlowExecution.getters.doneStepsBasedOnOneDoneGroup(state).findIndex((ds) => ds.id == FlowExecution.getters.currentStepToExecute(state).id);
    },
    lastDoneStep(state) {
      return state.done_steps.filter((ds) => ds.kind == "item").pop()
    },
    blockedStep(state) {
      return state.done_steps.find((ds) => ds.status == "blocked")
    }
  },

  mutations: {
    setDoneFlow(state, done_flow) {
      state.done_flow = {...done_flow};
    },
    setDoneFlowStatus(state, status) {
      state.done_flow.status = status;
    },
    setDoneGroups(state, done_groups) {
      state.done_groups = [...done_groups];
    },
    setDoneSteps(state, done_steps) {
      state.done_steps = [...done_steps];
    },
    setDoneItemSteps(state, done_item_steps) {
      state.done_steps = state.done_steps.map((ds) => {
        const dis = done_item_steps.find((dis) => dis.done_step_id == ds.id);
        return {...ds, done_item_step: dis};
      });
    },
    setOneDoneGroup(state, done_group) {
      state.one_done_group = {...done_group};
    },
    setOneDoneStep(state, done_step) {
      // console.log("done_step => ", done_step);
      if (done_step.kind == "item") {
        state.one_done_step = {...done_step};
      } else if (done_step.kind == "divisor"){
        state.one_done_step = {...done_step};
      } else {
        state.one_done_step = {};
      }
    },
    clearOneDoneGroup(state) {
      state.one_done_group = {};
    },
    clearOneDoneStep(state) {
      state.one_done_step = {};
    },
    clearDoneFlow(state) {
      state.done_flow = {};
    },
    clearDoneGroups(state) {
      state.done_groups = [];
    },
    clearDoneSteps(state) {
      state.done_steps = [];
    },
    clearExecution(state) {
      state.done_flow = {};
      state.done_groups = [];
      state.done_steps = [];
    },
    setDoneStepPhotoCompressed(state, photo_compressed) {
      state.one_done_step.done_item_step.photo_compressed = photo_compressed;
    },
    setCurrentStepToExecute(state) {
      const step = FlowExecution.getters.currentStepToExecute(state);
      const first_step = state.done_steps.find((ds) => ds.kind == "item");
      state.one_done_step = step ? step : first_step;

      state.one_done_group = {...state.done_groups.find((dg) => dg.id == state.one_done_step.done_group_id)};
    },
    goToNextDoneStep(state) {
      const current_done_step = {...state.one_done_step};
      const current_done_group = {...state.one_done_group};

      const done_steps_kind_item = state.done_steps.filter((ds) => ds.kind == "item");

      const idx_current_done_step = done_steps_kind_item.findIndex((ds) => ds.id == current_done_step.id);
      const idx_current_done_group = state.done_groups.findIndex((dg) => dg.id == current_done_group.id);

      if (idx_current_done_step < done_steps_kind_item.length - 1) {
        state.one_done_step = {...done_steps_kind_item[idx_current_done_step + 1]};
      }

      if (current_done_step.done_group_id != state.one_done_step.done_group_id) {
        state.one_done_group = {...state.done_groups[idx_current_done_group + 1]};
      }
    },
    setUpdatedDoneStep(state, done_step) {
      let current_done_step = {...FlowExecution.getters.currentStepToExecute(state)};
      const current_idx = state.done_steps.findIndex((ds) => ds.id == current_done_step.id);
      const done_step_idx = state.done_steps.findIndex((ds) => ds.id == done_step.id);
      let idx = null

      let {done_item_step, ...rest} = done_step;

      let IS_TO_UPDATE_CURRENT_STEP = false 
      if (current_done_step.id == done_step.id){
        IS_TO_UPDATE_CURRENT_STEP = true
      }

      let updated_step= {}

      if (IS_TO_UPDATE_CURRENT_STEP){
        idx = current_idx
        updated_step = {
          ...current_done_step, 
          ...rest,
          done_item_step: {
            ...current_done_step.done_item_step,
            ...done_item_step
          }
        };
      } else {
        idx = done_step_idx
        let existing_done_step = state.done_steps[done_step_idx]

        updated_step = {
          ...existing_done_step, 
          ...rest,
          done_item_step: {
            ...existing_done_step.done_item_step,
            ...done_item_step
          }
        };
      }

      state.done_steps.splice(idx, 1, {...updated_step});

      if (done_step.id == state.one_done_step.id) {
        state.one_done_step = {
          ...state.one_done_step,
          ...rest,
          done_item_step: {
            ...state.one_done_step.done_item_step,
            ...done_item_step
          }
        }
      }
    },
    updatedDoneStep(state, data) {
      const { 
        done_item_step_attributes: local_item_step_attributes,
        ...rest
      } = data.local_done_step;

      const {
        done_item_step: updated_item_step_attributes,
        ...updated_rest
      } = data.updated_done_step;
      
      const ds_updated = {
        ...rest,
        ...updated_rest,
        status: data.local_done_step.succeeded ? "done" : "blocked",
        done_item_step: {
          ...local_item_step_attributes,
          ...updated_item_step_attributes
        }
      };

      const idx = state.done_steps.findIndex((done_step) => done_step.id === ds_updated.id);

      state.done_steps.splice(idx, 1, {...ds_updated});
    }
  },

  actions: {
    getDoneFlow({commit, dispatch}, done_flow_id) {
      return Api.DoneFlow.showDoneFlow(done_flow_id).then(r => r.data).then(done_flow => {
        // console.log("done_flow => ", done_flow);
        commit("setDoneFlow", done_flow.done_flow);
        commit("setDoneGroups", done_flow.done_groups);
        commit("setDoneSteps", done_flow.done_steps);
        commit("setDoneItemSteps", done_flow.done_item_steps);
        commit("setCurrentStepToExecute")
        return done_flow.done_flow.id
      }).catch(error => {
        console.log(error);
        throw error
      })
    },
    getExecution({commit, dispatch}, {flow_id, version_control}) {
      return Api.Flow.beginExecution(flow_id, version_control).then(r => r.data).then(execution => {
        // console.log("execution => ", execution);
        commit("setDoneFlow", execution.done_flow);
        commit("setDoneGroups", execution.done_groups);
        commit("setDoneSteps", execution.done_steps);
        commit("setDoneItemSteps", execution.done_item_steps);
        commit("setCurrentStepToExecute");

        return execution;
      }).catch(error => {
        console.log(error);
      })
    },
    async updateDoneStep({commit, dispatch, state}, done_step) {
      let done_step_to_update = {...done_step};

      let photo_compressed = done_step.photo_compressed;
      if (photo_compressed) {
        try {
          photo_compressed = await transform_files_to_direct_upload(photo_compressed);
          done_step_to_update.done_item_step.photo_compressed = photo_compressed;
          // commit("setDoneStepPhotoCompressed", photo_compressed);
        } catch (error) {
          console.log(error);
        }
      }

      const {done_item_step, ...rest} = done_step_to_update;
      done_step_to_update = {
        done_item_step_attributes: {...done_item_step},
        ...rest
      };

      let notification = {};

      return Api.Flow.updateDoneStep(done_step_to_update).then((r) => r.data).then((r) => {
        const to_update_data = {
          local_done_step: {...done_step_to_update},
          updated_done_step: {...r}
        };
        commit("updatedDoneStep", to_update_data);

        notification.type = "success";
        notification.msg = "Feito com sucesso";

        if (r.status == 'blocked'){
          commit('setDoneFlowStatus', 'interrupted')
        }

        return r;
      }).catch((error) => {
        notification.type = "error";
        console.log({error});
        if (error.response) {
          if (error.response.data) {
            if (error.response.data){
              notification.msg = Object.values(error.response.data).join('; ')
            }
          }
        } else {
          notification.msg = `Erro: ${error}`;
        }
      }).finally(() => {
        dispatch("Notification/add", notification, { root: true });
      });
    }
  }
};

export default FlowExecution;